import React from "react";
import { Row, Col, Card, CardBody, ButtonGroup } from "reactstrap";
import UpdateInfoModal               from "./UpdateInfoModal";
import MasiveUpdatePostulationState  from "./MasiveUpdatePostulationState";
import SendToHeadModal               from "./SendToHeadModal";
import MassiveNextStageModal         from "./MassiveNextStageModal";
import CourseInviteModal             from "./CourseInviteModal";
import CreateUserModal               from "./CreateUserModal";
import MoveToCourseModal             from "./MoveToCourseModal";

const ApplicantsTools = ({
                           isPostulation,
                           courseId,
                           workFlow,
                           reloadQuery,
                           showNotification,
                           applicantsSelected,
                           checkAllApplicant,
                           handleCheckAllApplicant,
                           isAdmin
                         }) => (
  <Row className="mb-3">
    <Col>
      <Card className="material-shadow">
        <CardBody>
          <input
            type="checkbox"
            onChange={handleCheckAllApplicant}
            checked={checkAllApplicant}
            className="float-left"
            style={{ marginRight: 20 }}
          />

          <ButtonGroup className="responsive-btn-group-vertical ml-3">
            <UpdateInfoModal
              courseId={courseId}
              showNotification={showNotification}
              _applicantsSelected={applicantsSelected}
            />

            {isPostulation ? (
              <>
                <MasiveUpdatePostulationState
                  courseId={courseId}
                  _applicantsSelected={applicantsSelected}
                  reloadQuery={reloadQuery}
                />
                <MassiveNextStageModal
                  courseId={courseId}
                  workFlow={workFlow}
                  _applicantsSelected={applicantsSelected}
                  reloadQuery={reloadQuery}
                  isAdmin={isAdmin}
                />
                <SendToHeadModal
                  courseId={courseId}
                  _applicantsSelected={applicantsSelected}
                  reloadQuery={reloadQuery}
                />
                <MoveToCourseModal
                  courseId={courseId}
                  _applicantsSelected={applicantsSelected}
                  reloadQuery={reloadQuery}
                />
              </>
            ) : (
              <>
                <CourseInviteModal
                  courseId={courseId}
                  showNotification={showNotification}
                  _applicantsSelected={applicantsSelected}
                />
                <MoveToCourseModal
                  courseId={null}
                  _applicantsSelected={applicantsSelected}
                  reloadQuery={reloadQuery}
                />
                <CreateUserModal
                  showNotification={showNotification}
                  reloadQuery={reloadQuery}
                />
              </>
            )}
          </ButtonGroup>
        </CardBody>
      </Card>
    </Col>
  </Row>
);

export default ApplicantsTools;
